window.done = () ->
  window.location.href = App.redirect

$ ->
  App.Model.User = Backbone.Model.extend({
    validation: {
      password: [
        {
          required: true
          msg: __('new_password_required')
        }
        {
          minLength: 8
          msg: __('password_min_length')
        }
      ]
      confirm: [
        {
          required: true
          msg: __('confirm_password_required')
        }
        {
          fn: (value, attr) ->
            if value != @get('password')
              return __('confirm_doesnt_match')
        }
      ]
      first_name: {
        required: true
        msg: __('cart_first_name_required') }
      last_name: {
        required: true
        msg: __('cart_last_name_required') }
      email: [
        {
          required: true
          msg: __('cart_email_required')
        }
        {
          pattern: 'email'
          msg: __('cart_email_invalid')
        }
      ]
    }
  })

  App.View.Register = Backbone.View.extend {
    el: '#register'
    events: {
      'click #submit': 'precheck'
      'change input': 'changed' }
    initialize: ->
      @model = App.user
      $('#email').val($('#email').val()).trigger('change')
      Backbone.Validation.bind this, {
        valid: validInput
        invalid: invalidInput }
    changed: viewUpdateModel
    precheck: ->
      if !App.checkNewCustomer(@register, this)
        return
    register: ->
      errors = @model.validate()
      fail = $('#register-failed')
      fail.html ''
      fail.hide()
      if !errors
        $.post '/user/register', @model.toJSON(), (json) ->
          if json.success
            window.location.href = '/user/details'
          else if json.message
            fail.html json.message
            fail.show()
  }

  App.checkNewCustomer = (callback, context) ->
    email = $('#email').val()
    fail = $('#register-failed')
    if !email
      fail.html __('enter_email')
      fail.show()
      return false
    $.post '/user/exists', { email: email }, (data) ->
      if data.exists
        fail.html __('register_email_exists')
        fail.show()
        return false
      else
        $('#register-failed').html __('')
        fail.hide()
        callback.call(context)

  if App.is_logged
    $('.show-user').show()
    $('.show-no-user').hide()
  else
    $('.show-no-user').show()
    App.user = new App.Model.User()
    App.register = new App.View.Register()